import { useQuery, useMutation, useQueryClient } from 'react-query';
import { generalConfigApi, GeneralConfig } from '../api/generalConfig';

export const useGeneralConfig = () => {
  const queryClient = useQueryClient();

  const {
    data: config,
    isLoading,
    error,
    refetch,
  } = useQuery('generalConfig', generalConfigApi.getConfig, {
    refetchInterval: 60000, // Refetch every minute
  });

  const updateConfigMutation = useMutation(
    (configData: GeneralConfig) => generalConfigApi.updateConfig(configData),
    {
      onSuccess: (_result, variables) => {
        queryClient.setQueryData('generalConfig', variables);
        queryClient.invalidateQueries('generalConfig');
      },
    }
  );

  return {
    config,
    isLoading,
    error,
    refetch,
    updateConfig: updateConfigMutation.mutate,
    updateConfigAsync: updateConfigMutation.mutateAsync,
    isUpdating: updateConfigMutation.isLoading,
  };
};
